import * as React from "react";
import { useTranslation } from "react-i18next";
import { Row, Col, Alert } from "components/bootstrap";
const AuthBackendSubmitError = ({ error, backendId }) => {
  var _a, _b;
  const { t } = useTranslation("enterprise_authentication");
  return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { xs: 9, xsOffset: 3 }, /* @__PURE__ */ React.createElement(
    Alert,
    {
      bsStyle: "danger",
      style: { wordBreak: "break-word" },
      title: backendId ? t("auth_backend_submit_error.title_edit") : t("auth_backend_submit_error.title_create")
    },
    (error == null ? void 0 : error.message) && /* @__PURE__ */ React.createElement(React.Fragment, null, error.message, /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement("br", null)),
    (_b = (_a = error == null ? void 0 : error.additional) == null ? void 0 : _a.res) == null ? void 0 : _b.text
  )));
};
export default AuthBackendSubmitError;
